<template>
  <div class="news">
    <div class="container-custom">
      <div v-if="!isPostPage" class="news__header">
        <h2 class="news__header--title">
          {{ NEWS.title }}
        </h2>
        <div class="news__header--category">
          <ListCategory
            :list-category="categoryListData || []"
            :post-category-alias="postCategoryAliasComputed"
            @change-category="onChangeCategory"
          />
        </div>
        <slot name="header" />
      </div>
      <div class="news__content">
        <NuxtPage />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { NEWS } from '~/config/news'
import ListCategory from '~/components/desktop/pages/news/list-category.vue'
import { useCategories } from '~/composables/news/useCategories'
import NewIndex from '~/components/desktop/pages/news/index.vue'
import NewCategory from '~/components/desktop/pages/news/category.vue'
const route = useRoute()

const { getCategories, categoryList, onChangeCategory } = useCategories()

const isPostPage = computed(() => {
  return route?.name === NEWS.pathDetailPage
})

const { data: categoryListData } = await useAsyncData(async () => {
  await getCategories()
  return categoryList.value || []
})

const postCategoryAliasComputed = computed(() => {
  return route.params.Slug as string || 'all'
})

</script>

<style scoped lang="scss" src="public/assets/scss/components/desktop/layouts/news/index.scss" />
